import styled, { css } from 'styled-components';
import { Colors } from '../../colors';
import { HELPER_CLASS } from './consts';
import { mediaQueries } from '../../providers/MediaQueryProvider';
const WIDTH = 85;
const HEIGHT = 114;
export const Image = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 2px;

  ${({ inactive }) => inactive &&
    `
    opacity: 0.4;
  `}
`;
export const DragAndDropAnchorWrapper = styled.div `
  display: none;

  ${mediaQueries.tablet} {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
  }
`;
export const DragAndDropAnchorButton = styled.div `
  background: ${Colors.GS0};
  padding: 6px;
  margin-top: 4px;
  margin-left: 4px;
  border: 1px solid ${Colors.GS500};
  border-radius: 2px;
  cursor: grab;

  svg {
    path {
      stroke: ${Colors.GS1000};
      stroke-width: 1;
    }
  }

  &:hover {
    background-color: ${Colors.GS200};
  }
`;
export const TrashButtonWrapper = styled.div `
  display: none;
  cursor: pointer;

  ${mediaQueries.tablet} {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    z-index: 1;
  }
`;
export const TrashButton = styled.div `
  background: ${Colors.GS0};
  padding: 6px;
  margin-top: 4px;
  margin-right: 4px;
  border: 1px solid ${Colors.GS500};
  border-radius: 2px;

  &:hover {
    background-color: ${Colors.GS200};
  }

  svg {
    path {
      stroke: ${Colors.GS1000};
      stroke-width: 1;
    }
  }
`;
export const ImageContainer = styled.div `
  position: relative;
  aspect-ratio: 3/4;
  background-color: ${Colors.GS200};

  &:after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 2px solid transparent;
  }

  &:hover {
    &:after {
      border: 1px solid rgba(0, 0, 0, 0.16);
    }

    ${TrashButtonWrapper} {
      opacity: 1;
    }

    ${DragAndDropAnchorWrapper} {
      opacity: 1;
    }
  }
`;
export const LoaderContainer = styled.div `
  aspect-ratio: 3/4;
  background-color: ${Colors.GS200};
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 24px;
  justify-content: center;
`;
export const Item = styled.div `
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'grab')};

  grid-column: span 1;
  text-align: center;

  &.${HELPER_CLASS} {
    pointer-events: auto !important;
    cursor: grabbing;
  }

  &:hover {
    z-index: 2;
  }
`;
export const ItemWrapper = styled.div `
  position: relative;
`;
export const Placeholder = styled.div `
  position: absolute;
  background-color: ${Colors.GS200};
`;
export const UploadZone = styled.div ``;
export const Container = styled.div `
  display: grid;
  user-select: none;

  ${({ columns }) => columns
    ? `grid-template-columns: repeat(${columns}, 1fr);`
    : `grid-template-columns: repeat(auto-fill, minmax(${WIDTH}px, 1fr));`}

  ${({ columns }) => columns
    ? css `
          ${ImageContainer} {
            min-width: ${WIDTH}px;
            min-height: ${HEIGHT}px;
          }

          ${LoaderContainer} {
            min-width: ${WIDTH}px;
            min-height: ${HEIGHT}px;
          }
        `
    : ''};

  gap: 8px;
  width: 100%;
  margin: 0 auto;

  ${UploadZone} {
    min-width: ${WIDTH}px;
    min-height: ${HEIGHT}px;
    aspect-ratio: 3/4;
  }
`;
export const Divider = styled.div `
  grid-column: 1 / -1;
  margin: 8px 0;

  svg {
    path {
      stroke: ${Colors.GS600};
      stroke-width: 1;
    }
  }
`;
export const DividerText = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 2;
`;
export const UploadZoneWrapper = styled.div `
  aspect-ratio: 3/4;
  border-radius: 2px;
`;
